export default __webpack_public_path__ + "static/silverSDetail-efe6a5448d372f2b51a7613f0d5c853c.png";